import { render, staticRenderFns } from "./task-buttons-dropdown.vue?vue&type=template&id=6710be80&scoped=true"
import script from "./task-buttons-dropdown.vue?vue&type=script&lang=js"
export * from "./task-buttons-dropdown.vue?vue&type=script&lang=js"
import style0 from "./task-buttons-dropdown.vue?vue&type=style&index=0&id=6710be80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710be80",
  null
  
)

export default component.exports